import styled from "styled-components";
export const AgentWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
`;

export const AgentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
`;

export const AgentTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111;
`;

export const AgentBody = styled.div`
  padding: 12px;
`;
